export default [
    {
        path: '/old/notiList',
        name: 'notiList',
        component: () => import('@/views/old/etc/noti/notiList.vue')
    },
    {
        path: '/old/notiDetl/:blbdNo',
        name: 'notiDetl',
        component: () => import('@/views/old/etc/noti/notiDetl.vue'),
        props: true
    },
    {
        path: '/old/qnaList',
        name: 'qnaList',
        component: () => import('@/views/old/etc/qna/qnaList.vue')
    },
    {
        path: '/old/alamHist',
        name: 'alamHist',
        component: () => import('@/views/old/etc/alam/alamHist.vue')
    },
    {
        path: '/old/alamSet',
        name: 'alamSet',
        component: () => import('@/views/old/etc/alam/alamSet.vue')
    },
    {
        path: '/old/csSupport',
        name: 'csSupport',
        component: () => import('@/views/old/etc/cs/csSupport.vue')
    },
    {
        path: '/old/psnlInfo',
        name: 'psnlInfo',
        component: () => import('@/views/old/etc/cs/psnlInfo.vue')
    },
    {
        path: '/old/userManual',
        name: 'userManual',
        component: () => import('@/views/old/etc/cs/userManual.vue')
    },
]